'use strict';

import {
  initManager,
  isSubmenuVisible,
  removeSubmenuButtons,
  showSubmenuIconsAndButtons
} from '@jspartials/menu-utils';

function getSubmenuInfo() {
  const params = new URLSearchParams();
  const assetsListContainer =
    document.querySelector('[data-assets-list]') || {};
  params.append('assetsList', assetsListContainer.dataset.assetsList);

  fetch(`${globalVariables.endpoint.submenuInfo}?${params.toString()}`, {
    method: 'GET'
  })
    .then((response) => {
      if (!response.ok) {
        console.log('error');
      } else {
        response.json().then((data) => {
          const submenuAssetsInfo = data.assetsContent;

          Object.keys(submenuAssetsInfo).forEach((key) => {
            sessionStorage.setItem(key, JSON.stringify(submenuAssetsInfo[key]));
            !isSubmenuVisible(submenuAssetsInfo[key]) &&
              removeSubmenuButtons(key);
          });

          showSubmenuIconsAndButtons();
        });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
}

export const initMenu = () => {
  getSubmenuInfo();
  initManager();
};

document.addEventListener('DOMContentLoaded', initMenu);
